import { useLocation } from 'react-router-dom';
import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/css/image-gallery.css';
import './ProjectDetails.css';

function ProjectDetails() {
    
    const importImages = (r) => {
        return r.keys().map((item) => {
            const img = r(item);
            return {
                original: img,
                thumbnail: img,
            };
        });
    };

    const location = useLocation();
    const projectID = location.state.projectID;

    let images;
    switch (projectID) {
        case "proj1":
            images = importImages(require.context('../assets/projectOne', false, /\.(jpg|jpeg|png)$/));
            break;
        case "proj2":
            images = importImages(require.context('../assets/projectTwo', false, /\.(jpg|jpeg|png)$/));
            break;
        case "proj3":
            images = importImages(require.context('../assets/projectThree', false, /\.(jpg|jpeg|png)$/));
            break;
        case "proj4":
            images = importImages(require.context('../assets/projectFour', false, /\.(jpg|jpeg|png)$/));
            break;
        case "proj5":
            images = importImages(require.context('../assets/projectFive', false, /\.(jpg|jpeg|png)$/));
            break;
        case "proj6":
            images = importImages(require.context('../assets/projectSix', false, /\.(jpg|jpeg|png)$/));
            break;
        case "proj7":
            images = importImages(require.context('../assets/projectSeven', false, /\.(jpg|jpeg|png)$/));
            break;
        case "proj8":
            images = importImages(require.context('../assets/projectEight', false, /\.(jpg|jpeg|png)$/));
            break;
        case "other":
            images = importImages(require.context('../assets/otherProjects', false, /\.(jpg|jpeg|png)$/));
            break;
        default:
            images = [];
    }

    return (
        <div className="project-details">
            <ImageGallery items={images} />;      
        </div>
    );
}

export default ProjectDetails;
